module.exports = __webpack_public_path__ + "static/media/Turn It Up (Rewind Selecta).fd023043.jpg";